import {
  Component,
} from "react";
import {
  Link,
} from "react-router-dom";
import {
  Button,
} from "react-bootstrap";

import Breadcrumb from "CommonComponents/breadcrumb";
import {
  MnDetailEditor,
} from "App/mn-detail-page";
import massnahmeApi from "Apis/massnahme-api";
import {
  popComponent,
} from "CommonCore/location-util";

const BackToAntragButton = props => <Link to={popComponent({ pathname: popComponent(location) })}> <Button {...props}>Zurück zum Antrag</Button> </Link>;

@massnahmeApi.current
export default class AntragMnEditor extends Component {
  render() {
    const { route } = this.props;
    return <div>
      <Breadcrumb name='Massnahme' route={route} />
      <BackToAntragButton style={{ marginBottom: "1em" }} />
      <MnDetailEditor />
      <BackToAntragButton />
    </div>;
  }
}
